import AtlantaImage from '@/images/destinations/popular/atlanta.jpg'
import AtlantaImageWebP from '@/images/destinations/popular/atlanta.webp'
import DallasImage from '@/images/destinations/popular/dallas.jpg'
import DallasImageWebP from '@/images/destinations/popular/dallas.webp'
import DenverImage from '@/images/destinations/popular/denver.jpg'
import DenverImageWebP from '@/images/destinations/popular/denver.webp'
import LosAngelesImage from '@/images/destinations/popular/los-angeles.jpg'
import LosAngelesImageWebP from '@/images/destinations/popular/los-angeles.webp'
import MiamiImage from '@/images/destinations/popular/miami.jpg'
import MiamiImageWebP from '@/images/destinations/popular/miami.webp'
import NewYorkImage from '@/images/destinations/popular/new-york-city.jpg'
import NewYorkImageWebP from '@/images/destinations/popular/new-york-city.webp'
import OrlandoImage from '@/images/destinations/popular/orlando.jpg'
import OrlandoImageWebP from '@/images/destinations/popular/orlando.webp'
import SanDiegoImage from '@/images/destinations/popular/san-diego.jpg'
import SanDiegoImageWebP from '@/images/destinations/popular/san-diego.webp'
import SanFranciscoImage from '@/images/destinations/popular/san-francisco.jpg'
import SanFranciscoImageWebP from '@/images/destinations/popular/san-francisco.webp'
import SeattleImage from '@/images/destinations/popular/seattle.jpg'
import SeattleImageWebP from '@/images/destinations/popular/seattle.webp'
import {
  Atlanta,
  Dallas,
  Denver,
  Miami,
  NewYork,
  LosAngeles,
  Orlando,
  SanDiego,
  SanFrancisco,
  Seattle
} from './svgs'

const DESTINATIONS = [
  {
    driveSearchHref: '/rental-car-deals/new-york.15830.ksp',
    flySearchHref: '/flight-routes/New-York-NYC.ksp',
    staySearchHref: '/hotel-deals/c3000016152/US/New-York/New-York-Hotels.html',
    searchCity: 'New York',
    image: NewYorkImage,
    imageWebP: NewYorkImageWebP,
    svg: NewYork,
    title: '24-HOUR EXCITEMENT',
    width: [1, 1, 1 / 2, 1 / 2, 2 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/los-angeles.16078.ksp',
    flySearchHref: '/flight-routes/Los-Angeles-LAX.ksp',
    staySearchHref:
      '/hotel-deals/c3000001947/US/California/Los-Angeles-Hotels.html',
    searchCity: 'Los Angeles',
    image: LosAngelesImage,
    imageWebP: LosAngelesImageWebP,
    svg: LosAngeles,
    title: 'CUTTING-EDGE COOL',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/orlando.9900.ksp',
    flySearchHref: '/flight-routes/Orlando-ORL.ksp',
    staySearchHref: '/hotel-deals/c3000003349/US/Florida/Orlando-Hotels.html',
    searchCity: 'Orlando',
    image: OrlandoImage,
    imageWebP: OrlandoImageWebP,
    svg: Orlando,
    title: 'THEME PARK PARADISE',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/atlanta.11123.ksp',
    flySearchHref: '/flight-routes/Atlanta-Hartsfield-Jackson-ATL.ksp',
    staySearchHref: '/hotel-deals/c3000003496/US/Georgia/Atlanta-Hotels.html',
    searchCity: 'Atlanta',
    image: AtlantaImage,
    imageWebP: AtlantaImageWebP,
    svg: Atlanta,
    title: 'SWEET SOUTHERN CHARM',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/dallas.16406.ksp',
    flySearchHref: '/flight-routes/Dallas-A78.ksp',
    staySearchHref: '/hotel-deals/c3000021082/US/Texas/Dallas-Hotels.html',
    searchCity: 'Dallas',
    image: DallasImage,
    imageWebP: DallasImageWebP,
    svg: Dallas,
    title: 'FOOD CAPITAL',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/san-francisco.13852.ksp',
    flySearchHref: '/flight-routes/San-Francisco-SFO.ksp',
    staySearchHref:
      '/hotel-deals/c3000002244/US/California/San-Francisco-Hotels.html',
    searchCity: 'San Francisco',
    image: SanFranciscoImage,
    imageWebP: SanFranciscoImageWebP,
    svg: SanFrancisco,
    title: 'SOAK UP THE SCENES',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/miami.14305.ksp',
    flySearchHref: '/flight-routes/Miami-MIA.ksp',
    staySearchHref: '/hotel-deals/c3000003311/US/Florida/Miami-Hotels.html',
    searchCity: 'Miami',
    image: MiamiImage,
    imageWebP: MiamiImageWebP,
    svg: Miami,
    title: "IT'S BEACH TIME",
    width: [1, 1, 1 / 2, 1 / 2, 2 / 3]
  },
  {
    flySearchHref: '/flight-routes/Denver-Intl-DEN.ksp',
    driveSearchHref: '/rental-car-deals/denver.12493.ksp',
    staySearchHref: '/hotel-deals/c3000002573/US/Colorado/Denver-Hotels.html',
    searchCity: 'Denver',
    image: DenverImage,
    imageWebP: DenverImageWebP,
    svg: Denver,
    title: 'MILE-HIGH MAGIC',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    flySearchHref: '/flight-routes/Seattle-Tacoma-Intl-SEA.ksp',
    driveSearchHref: '/rental-car-deals/seattle.7054.ksp',
    staySearchHref:
      '/hotel-deals/c3000023414/US/Washington/Seattle-Hotels.html',
    searchCity: 'Seattle',
    image: SeattleImage,
    imageWebP: SeattleImageWebP,
    svg: Seattle,
    title: 'PACIFIC NORTHWEST BEAUTY',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  },
  {
    driveSearchHref: '/rental-car-deals/san-diego.10760.ksp',
    flySearchHref: '/flight-routes/San-Diego-SAN.ksp',
    staySearchHref:
      '/hotel-deals/c3000002241/US/California/San-Diego-Hotels.html',
    searchCity: 'San Diego',
    image: SanDiegoImage,
    imageWebP: SanDiegoImageWebP,
    svg: SanDiego,
    title: 'RIDE THE WAVES',
    width: [1, 1, 1 / 2, 1 / 2, 1 / 3]
  }
]

export default DESTINATIONS
